import React, { Fragment, useState } from 'react'
// Import the main component
import { Viewer } from '@react-pdf-viewer/core'; // install this library
// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'; // install this library
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// Worker
import { Worker } from '@react-pdf-viewer/core'; // install this library
import estilos from './AtencionAClientesFC_01Component.module.css';

function PrevisualizarAchivoComponent(props) {

    // Create new plugin instance
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    const { archivo } = props

    return (
        <Fragment>
            <div className='container'>
                <div className={`${estilos.visualizadorPDF}`}>
                    {archivo && <><Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js">
                        <Viewer fileUrl={archivo}
                            plugins={[defaultLayoutPluginInstance]} />
                    </Worker></>}
                    {/* if we dont have pdf or viewPdf state is null */}
                    {!archivo && <>No pdf file selected</>}
                </div>

            </div>
        </Fragment>
    )
}

export default PrevisualizarAchivoComponent
